<div class="min-h-screen overflow-x-hidden xl:flex">
  <div>
    <app-sidebar></app-sidebar>
    <app-backdrop></app-backdrop>
  </div>
  <div
    class="min-w-0 flex-1 transition-all duration-300 ease-in-out"
    [ngClass]="{
      'xl:ml-72.5': (isExpanded$ | async) || (isHovered$ | async),
      'xl:ml-22.5': !(isExpanded$ | async) && !(isHovered$ | async),
      'ml-0': (isMobileOpen$ | async),
    }"
  >
    <!-- app header start -->
    <app-header />
    <!-- app header end -->
    <div
      class="mx-auto min-h-[calc(100vh-84px)] min-w-0 overflow-x-hidden bg-cover bg-center bg-no-repeat p-4 md:p-6"
      style="background-image: url('/images/shape/bg-white-palace.svg')"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
